angular.module('gym.components').directive('integrapayCreditCardForm', function() {
  return {
    restrict: 'EA',
    scope: {
      card: '=',
      contact: '=',
      customer: '=',
      form: '=',
      gym: '=',
      isDisabled: '=',
      token: '='
    },
    template: require('templates/components/contacts/wallet/integrapay_credit_card_form.html.slim'),
    controller: ["$scope", "$sce", "CreditCardValidationService", "CreditCardExpirationDatesService", function($scope, $sce, CreditCardValidationService, CreditCardExpirationDatesService) {
      $scope.years = CreditCardExpirationDatesService.getYears();
      $scope.months = CreditCardExpirationDatesService.getMonths();
      $scope.resourceUrl = $sce.trustAsResourceUrl($scope.token.vault_url);
      $scope.checkCardNumber = function() {
        var ref;
        $scope.card.CreditCardNumber = (ref = $scope.card.CreditCardNumber) != null ? ref.replace(/[^0-9]/g, '') : void 0;
        return $scope.creditCardValid = CreditCardValidationService.check($scope.card.CreditCardNumber);
      };
      return $scope.checkName = function(name) {
        return $scope.nameValid = CreditCardValidationService.nameValid(name);
      };
    }]
  };
});
